import type React from "react";
import type { LineDetails, Stop, Zone } from "../../../types";
import { fitBoundsForStops, fitBoundsForZones } from "../../../utils/fitBounds";

export const rootIdOf = (id: string | number) => String(id).split("-")[0];

export const stopKeyOf = rootIdOf;

export function clearPolylineRefs(
  polyRefs: React.MutableRefObject<Record<string, google.maps.Polyline[]>>
) {
  const refs = polyRefs.current;

  Object.keys(refs).forEach((key) => {
    const arr = refs[key];

    if (arr) {
      arr.forEach((p) => p.setMap(null));
    }

    delete refs[key];
  });
}

export function clearPolylineRefById(
  polyRefs: React.MutableRefObject<Record<string, google.maps.Polyline[]>>,
  idRaw: string | number
) {
  const id = String(idRaw);
  const arr = polyRefs.current[id];

  if (!arr) return;

  arr.forEach((p) => p.setMap(null));
  delete polyRefs.current[id];
}

export function zoomToLine(
  map: google.maps.Map | null,
  line: LineDetails,
  padding = 60
) {
  if (!map) return;

  const pts = line.paths.length
    ? ([] as google.maps.LatLngLiteral[]).concat(...line.paths)
    : line.stops.map((s) => ({ lat: s.lat, lng: s.lng }));

  const bounds = new google.maps.LatLngBounds();

  pts.forEach((p) => bounds.extend(p));

  map.fitBounds(bounds, padding);
}

export function zoomToStops(map: google.maps.Map | null, stops: Stop[]) {
  if (!map || stops.length === 0) return;
  fitBoundsForStops(map, stops);
}

export function zoomToZone(map: google.maps.Map | null, zone: Zone) {
  if (!map) return;
  fitBoundsForZones(map, [zone]);
}
